// LocalStorageService.js
const LocalStorageService = (function() {
  var _service;

  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }

    return _service;
  }

  function _setStationInfo(stationData) {
    localStorage.setItem("station_info", JSON.stringify(stationData));
  }

  function _removeStationInfo() {
    localStorage.removeItem("station_info");
  }

  function _clearUser() {
    localStorage.removeItem("user");
    localStorage.removeItem("access_keys");
  }

  function _getStationInfo() {
    return JSON.parse(localStorage.getItem("station_info"));
  }

  function _setAccessKeys(tokenObj) {
    let accessObj = {
      "access-token": tokenObj["access-token"],
      client: tokenObj["client"],
      uid: tokenObj["uid"],
      expiry: tokenObj["expiry"]
    };

    localStorage.setItem("access_keys", JSON.stringify(accessObj));
  }

  function _removeAccessKeys() {
    localStorage.removeItem("access_keys");
  }

  function _getAccessKeys() {
    return JSON.parse(localStorage.getItem("access_keys"));
  }

  return {
    getService: _getService,
    setAccessKeys: _setAccessKeys,
    getAccessKeys: _getAccessKeys,
    setStationInfo: _setStationInfo,
    removeStationInfo: _removeStationInfo,
    getStationInfo: _getStationInfo,
    removeAccessKeys: _removeAccessKeys,
    clearUser: _clearUser
  };
})();

export default LocalStorageService;
